
import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { isArchivedFilter } from '../data'

interface PIICategoryType {
  CategoryName: string,
  CategoryType: string,
  EKey?: string
  ETag?: string
}
interface PIICategoryTypeMetadataArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}
const LIST_NAME = 'PIICategoryTypeList'
const COLUMN_NAMES = {
  CategoryName: "CategoryName",
  CategoryType: "CategoryType",
  EKey: "eKey",
  ETag: "eTag"
}
const getPIICategoryTypeListMetadata = async (
  args: PIICategoryTypeMetadataArgs
): Promise<PIICategoryType[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.CategoryName

  const items = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.CategoryType,
      COLUMN_NAMES.CategoryName,
      COLUMN_NAMES.EKey,
      COLUMN_NAMES.ETag,
    )
    .expand('ItemCreatedBy', 'ItemModifiedBy')
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as PIICategoryType[]
}
export {
  COLUMN_NAMES,
  LIST_NAME,
  type PIICategoryType,
  type PIICategoryTypeMetadataArgs,
  getPIICategoryTypeListMetadata
}